export const findDefaultDate = (
  thisQuestion: ObjectStringKeyAnyValue,
  setQuestionAnswer: React.Dispatch<React.SetStateAction<any>>,
  includeTime: boolean = false
) => {
  if (!thisQuestion) {
    console.log("⛔️ No question data available to set default date");
    return;
  }

  const DatesToInclude = thisQuestion.DateOptions;
  const DateDefaultDirection = thisQuestion.DateDefaultDirection;
  const DateDefaultOffset = thisQuestion.DateDefaultOffset || 0;
  console.log(
    `📆 Setting default date. Dates to include: ${DatesToInclude}. Direction: ${DateDefaultDirection}. Offset: ${DateDefaultOffset}`
  );

  if (!DateDefaultDirection || !DateDefaultOffset || !DatesToInclude) {
    console.log("⛔️ No default date to set - missing parameters");
    return;
  }

  if (DateDefaultOffset) {
    const offsetNumber = parseInt(DateDefaultOffset, 0);

    if (DateDefaultDirection === "Past") {
      if (DatesToInclude === "Past" || DatesToInclude === "PastAndFuture") {
        console.log("Setting default date to Past with offset", offsetNumber);
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - offsetNumber);
        let formattedPastDate = `${pastDate.getFullYear()}-${String(
          pastDate.getMonth() + 1
        ).padStart(2, "0")}-${String(pastDate.getDate()).padStart(2, "0")}`;
        if (includeTime) {
          formattedPastDate += "T00:00";
        }
        console.log("Calculated past date:", formattedPastDate);
        setQuestionAnswer(formattedPastDate);
      } else {
        console.log(
          "⛔️ Cannot set default date - direction is Past but Dates to include does not allow Past dates"
        );
      }
    }

    if (DateDefaultDirection === "Future") {
      if (DatesToInclude === "Future" || DatesToInclude === "PastAndFuture") {
        console.log("Setting default date to Future with offset", offsetNumber);
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + offsetNumber);
        let formattedFutureDate = `${futureDate.getFullYear()}-${String(
          futureDate.getMonth() + 1
        ).padStart(2, "0")}-${String(futureDate.getDate()).padStart(2, "0")}`;
        if (includeTime) {
          formattedFutureDate += "T00:00";
        }
        console.log("Calculated future date:", formattedFutureDate);
        setQuestionAnswer(formattedFutureDate);
      } else {
        console.log(
          "⛔️ Cannot set default date - direction is Future but Dates to include does not allow Future dates"
        );
      }
    }
  }
};
